// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Aj-z","sponsoredTooltipWrapper":"Bj-z","sponsoredTooltip":"Cj-z","newCard":"Dj-z"};